// extracted by mini-css-extract-plugin
module.exports = {"banner":"StatusBanner_banner__dO_lx","error":"StatusBanner_error__DgLXd","invalid":"StatusBanner_invalid__2Y5or","label":"StatusBanner_label__1VuLE"};